var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useResponsiveProps, } from '@core-front/helper';
import ObjectFit from '@core-front/object-fit';
import { useTheme } from '@core-front/theme-provider';
import { CardContext } from '../card/card-core';
const CardContentCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    return responsive ? (React.createElement(CardContentResponsiveCore, Object.assign({}, rest, { responsive: responsive }))) : (React.createElement(CardContentInnerCore, Object.assign({}, rest)));
};
const CardContentResponsiveCore = (props) => {
    const { responsive } = props, rest = __rest(props, ["responsive"]);
    const { breakPoints } = useTheme();
    const responsiveProps = useResponsiveProps({ breakPoints, responsive });
    return React.createElement(CardContentInnerCore, Object.assign({}, rest, responsiveProps));
};
const CardContentInnerCore = (props) => {
    const { padding } = React.useContext(CardContext);
    const { children, className, elementRef, backgroundImage, borderRadius, style, tagTop, components: { Tag, Image }, } = props;
    const contentPadding = props.padding || padding;
    const BEM = () => {
        const classArray = ['card__content'];
        const isEqualHorizontally = typeof contentPadding !== 'string' && contentPadding['right'] && contentPadding['right'] === contentPadding['left'];
        const isEqualVertically = typeof contentPadding !== 'string' && contentPadding['top'] && contentPadding['top'] === contentPadding['bottom'];
        const addPaddingClass = (direction, size) => {
            if (size) {
                return classArray.push(`card__content--padding-${direction}-${size}`);
            }
        };
        if (className) {
            classArray.push(className);
        }
        if (typeof contentPadding === 'string') {
            classArray.push(`card__content--padding-${contentPadding}`);
        }
        else {
            classArray.push('card__content--padding-medium');
            if (isEqualHorizontally && isEqualVertically) {
                addPaddingClass('vertical', contentPadding['top']);
                addPaddingClass('horizontal', contentPadding['right']);
            }
            else if (isEqualHorizontally) {
                addPaddingClass('horizontal', contentPadding['right']);
                addPaddingClass('top', contentPadding['top']);
                addPaddingClass('bottom', contentPadding['bottom']);
            }
            else if (isEqualVertically) {
                addPaddingClass('vertical', contentPadding['top']);
                addPaddingClass('right', contentPadding['right']);
                addPaddingClass('left', contentPadding['left']);
            }
            else {
                Object.keys(contentPadding).forEach((key) => {
                    const direction = key;
                    addPaddingClass(direction, contentPadding[direction]);
                });
            }
        }
        if (tagTop) {
            classArray.push('card__content--with-tag');
        }
        if (typeof borderRadius === 'string') {
            classArray.push(`card__content--border-radius-${borderRadius}`);
        }
        else if (borderRadius) {
            Object.keys(borderRadius).forEach((key) => {
                const direction = key;
                classArray.push(`card__content--border-radius-${direction}-${borderRadius[direction]}`);
            });
        }
        if (backgroundImage) {
            classArray.push('card__content--with-background-image');
        }
        return classArray.join(' ');
    };
    const imageBEM = (image) => {
        const classArray = ['card__content-background-image'];
        if (image.className) {
            classArray.push(image.className);
        }
        return classArray.join(' ');
    };
    return (React.createElement("div", { className: BEM(), ref: elementRef, style: style },
        tagTop && (React.createElement("div", { className: "card__content-tag-wrapper" },
            React.createElement("div", { className: "card__content-tag-inner" }, typeof tagTop === 'object' && (React.createElement(Tag, Object.assign({ className: "card__content-tag" }, tagTop, { size: "tiny" })))))),
        backgroundImage && (React.createElement(ObjectFit, { fit: "cover", positionX: "center", positionY: "center", className: "card__content-object-fit" },
            React.createElement(Image, Object.assign({}, backgroundImage, { className: imageBEM(backgroundImage), pictureClassName: "card__content-background-image-picture" })))),
        children));
};
export { CardContentCore as default, CardContentResponsiveCore, };
